/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: GPT-5 Codex
 🏢 Company: Ring2All LLC
 📄 File: cdrFiltersActions.ts
 🗓️ Created: 2025-01-27
 🧩 Description:
    Shared helpers for CDR Filters actions.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteCdrFilter } from './api';

/**
 * Build the URL used to duplicate a CDR Filter in the form.
 */
export const getCdrFilterDuplicateUrl = (id: string | number): string =>
  `/reports/cdr/filters/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given CDR Filter id.
 */
export const navigateToCdrFilterDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getCdrFilterDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a CDR Filter by id.
 */
export const deleteCdrFilterById = async (id: string | number): Promise<void> => {
  await deleteCdrFilter(id);
};

